import { useEffect, useRef } from "react";
import { isMobile, scroll2Top } from "../../utils/utils";
import REInfoAttestationROBeneficiaryBloc from "../../blocs/retirement/info-perso/REInfoAttestationROBeneficiaryBloc";


export default function REInfoAttestationROBeneficiaryPage() {
    
    const pageGapRef = useRef<null | HTMLDivElement>(null);
    useEffect(() => {
      if (isMobile()) {
        pageGapRef.current?.scrollIntoView() 
      } else {
        scroll2Top();
      }
    }, []);

    
    return (
      <div className="entreprise-container">
        <h1 className="title ml-lg-desktop mb-sm fw-medium">Les attestations de droits de mes proches</h1>
        <p className="text ml-lg-desktop mt-sm" style={{textAlign: 'justify'}}></p>
        <div ref={pageGapRef} className="page-gap" />
        <div className="flex-grid m-lg-desktop">
            <REInfoAttestationROBeneficiaryBloc />
        </div>
      </div>
    )

}